
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUStockItemGrid extends Serenity.EntityGrid<SKUStockItemRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUStockItem'; }
        protected getDialogType() { return SKUStockItemDialog; }
        protected getIdProperty() { return SKUStockItemRow.idProperty; }
        protected getInsertPermission() { return SKUStockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUStockItemRow.localTextPrefix; }
        protected getService() { return SKUStockItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}